// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.covered-calls-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.covered-calls-header {
  margin-bottom: 20px;
}

.covered-calls-header h2 {
  margin: 0 0 5px 0;
  color: #333;
}

.covered-calls-header p {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

.covered-calls-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.covered-calls-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.covered-calls-controls > div {
  display: flex;
  align-items: center;
  gap: 8px;
}

.covered-calls-controls label {
  font-weight: 500;
  color: #555;
  white-space: nowrap;
}

.covered-calls-controls select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  background: white;
  cursor: pointer;
}

.covered-calls-controls select:hover {
  border-color: #999;
}

.covered-calls-controls select:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);
}

.covered-calls-table-container {
  overflow-x: auto;
}

.covered-calls-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
}

.covered-calls-table thead {
  background: #f5f5f5;
  border-bottom: 2px solid #ddd;
}

.covered-calls-table th {
  padding: 12px 10px;
  text-align: left;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.covered-calls-table td {
  padding: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.covered-calls-table tbody tr:hover {
  background: #f9f9f9;
}

.covered-calls-table .group-header-row {
  background: #f0f0f0;
  font-weight: 600;
  cursor: pointer;
}

.covered-calls-table .group-header-row:hover {
  background: #e8e8e8;
}

.covered-calls-table .symbol-group-header-row {
  background: #f5f5f5;
  font-weight: 500;
  cursor: pointer;
  padding-left: 20px;
}

.covered-calls-table .symbol-group-header-row:hover {
  background: #eeeeee;
}

.covered-calls-table .symbol-group-header-row:hover .expand-icon {
  background: #d0d0d0;
}

.covered-calls-table .symbol-group-cell {
  padding-left: 20px;
  font-weight: 500;
  color: #444;
}

.covered-calls-table .group-item-row {
  background: #fafafa;
}

.covered-calls-table .group-item-row .item-cell {
  padding-left: 40px;
}

.covered-calls-table .group-item-row:hover {
  background: #f0f0f0;
}

.covered-calls-table .item-cell {
  padding: 15px 10px;
}

.covered-calls-table .item-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 8px;
  font-size: 0.85rem;
}

.covered-calls-table .item-details div {
  display: flex;
  gap: 5px;
}

.covered-calls-table .item-details strong {
  color: #555;
  min-width: 80px;
}

.covered-calls-table .conid-cell,
.covered-calls-table .underlying-cell {
  font-weight: 500;
  color: #333;
}

.covered-calls-table .account-cell {
  color: #666;
}

.covered-calls-table .date-cell {
  color: #555;
  white-space: nowrap;
}

.covered-calls-table .number-cell {
  text-align: right;
  color: #555;
}

.covered-calls-table .pnl-cell {
  text-align: right;
  font-weight: 500;
  white-space: nowrap;
}

.covered-calls-table .pnl-cell.positive {
  color: #28a745;
}

.covered-calls-table .pnl-cell.negative {
  color: #dc3545;
}

.covered-calls-table .count-cell {
  text-align: center;
  color: #555;
}

.covered-calls-table .group-key-cell {
  font-weight: 600;
  color: #333;
}

.covered-calls-table .expand-cell {
  width: 40px;
  text-align: center;
  padding: 10px 5px;
}

.covered-calls-table .expand-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #666;
  background: #e0e0e0;
  border-radius: 3px;
  -webkit-user-select: none;
          user-select: none;
}

.covered-calls-table .group-header-row:hover .expand-icon {
  background: #d0d0d0;
}

.covered-calls-table .totals-row {
  background: #f5f5f5;
  border-top: 2px solid #ddd;
  font-weight: 600;
}

.covered-calls-table .totals-cell {
  padding: 12px 10px;
  color: #333;
}

.covered-calls-table .empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-style: italic;
}

.loading,
.error {
  text-align: center;
  padding: 40px 20px;
  font-size: 1.1rem;
}

.loading {
  color: #666;
}

.error {
  color: #dc3545;
}

@media (max-width: 768px) {
  .covered-calls-container {
    padding: 10px;
  }

  .covered-calls-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .covered-calls-controls > div {
    flex-direction: column;
    align-items: stretch;
  }

  .covered-calls-controls label {
    margin-bottom: 5px;
  }

  .covered-calls-table {
    font-size: 0.8rem;
  }

  .covered-calls-table th,
  .covered-calls-table td {
    padding: 8px 6px;
  }

  .covered-calls-table .item-details {
    grid-template-columns: 1fr;
  }
}

`, "",{"version":3,"sources":["webpack://./src/CoveredCalls.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".covered-calls-container {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.covered-calls-header {\n  margin-bottom: 20px;\n}\n\n.covered-calls-header h2 {\n  margin: 0 0 5px 0;\n  color: #333;\n}\n\n.covered-calls-header p {\n  margin: 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.covered-calls-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n}\n\n.covered-calls-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 20px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.covered-calls-controls > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.covered-calls-controls label {\n  font-weight: 500;\n  color: #555;\n  white-space: nowrap;\n}\n\n.covered-calls-controls select {\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  background: white;\n  cursor: pointer;\n}\n\n.covered-calls-controls select:hover {\n  border-color: #999;\n}\n\n.covered-calls-controls select:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.1);\n}\n\n.covered-calls-table-container {\n  overflow-x: auto;\n}\n\n.covered-calls-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n}\n\n.covered-calls-table thead {\n  background: #f5f5f5;\n  border-bottom: 2px solid #ddd;\n}\n\n.covered-calls-table th {\n  padding: 12px 10px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n}\n\n.covered-calls-table td {\n  padding: 10px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.covered-calls-table tbody tr:hover {\n  background: #f9f9f9;\n}\n\n.covered-calls-table .group-header-row {\n  background: #f0f0f0;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.covered-calls-table .group-header-row:hover {\n  background: #e8e8e8;\n}\n\n.covered-calls-table .symbol-group-header-row {\n  background: #f5f5f5;\n  font-weight: 500;\n  cursor: pointer;\n  padding-left: 20px;\n}\n\n.covered-calls-table .symbol-group-header-row:hover {\n  background: #eeeeee;\n}\n\n.covered-calls-table .symbol-group-header-row:hover .expand-icon {\n  background: #d0d0d0;\n}\n\n.covered-calls-table .symbol-group-cell {\n  padding-left: 20px;\n  font-weight: 500;\n  color: #444;\n}\n\n.covered-calls-table .group-item-row {\n  background: #fafafa;\n}\n\n.covered-calls-table .group-item-row .item-cell {\n  padding-left: 40px;\n}\n\n.covered-calls-table .group-item-row:hover {\n  background: #f0f0f0;\n}\n\n.covered-calls-table .item-cell {\n  padding: 15px 10px;\n}\n\n.covered-calls-table .item-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 8px;\n  font-size: 0.85rem;\n}\n\n.covered-calls-table .item-details div {\n  display: flex;\n  gap: 5px;\n}\n\n.covered-calls-table .item-details strong {\n  color: #555;\n  min-width: 80px;\n}\n\n.covered-calls-table .conid-cell,\n.covered-calls-table .underlying-cell {\n  font-weight: 500;\n  color: #333;\n}\n\n.covered-calls-table .account-cell {\n  color: #666;\n}\n\n.covered-calls-table .date-cell {\n  color: #555;\n  white-space: nowrap;\n}\n\n.covered-calls-table .number-cell {\n  text-align: right;\n  color: #555;\n}\n\n.covered-calls-table .pnl-cell {\n  text-align: right;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.covered-calls-table .pnl-cell.positive {\n  color: #28a745;\n}\n\n.covered-calls-table .pnl-cell.negative {\n  color: #dc3545;\n}\n\n.covered-calls-table .count-cell {\n  text-align: center;\n  color: #555;\n}\n\n.covered-calls-table .group-key-cell {\n  font-weight: 600;\n  color: #333;\n}\n\n.covered-calls-table .expand-cell {\n  width: 40px;\n  text-align: center;\n  padding: 10px 5px;\n}\n\n.covered-calls-table .expand-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n  color: #666;\n  background: #e0e0e0;\n  border-radius: 3px;\n  user-select: none;\n}\n\n.covered-calls-table .group-header-row:hover .expand-icon {\n  background: #d0d0d0;\n}\n\n.covered-calls-table .totals-row {\n  background: #f5f5f5;\n  border-top: 2px solid #ddd;\n  font-weight: 600;\n}\n\n.covered-calls-table .totals-cell {\n  padding: 12px 10px;\n  color: #333;\n}\n\n.covered-calls-table .empty-state {\n  text-align: center;\n  padding: 40px 20px;\n  color: #999;\n  font-style: italic;\n}\n\n.loading,\n.error {\n  text-align: center;\n  padding: 40px 20px;\n  font-size: 1.1rem;\n}\n\n.loading {\n  color: #666;\n}\n\n.error {\n  color: #dc3545;\n}\n\n@media (max-width: 768px) {\n  .covered-calls-container {\n    padding: 10px;\n  }\n\n  .covered-calls-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .covered-calls-controls > div {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .covered-calls-controls label {\n    margin-bottom: 5px;\n  }\n\n  .covered-calls-table {\n    font-size: 0.8rem;\n  }\n\n  .covered-calls-table th,\n  .covered-calls-table td {\n    padding: 8px 6px;\n  }\n\n  .covered-calls-table .item-details {\n    grid-template-columns: 1fr;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
